export const Tiktok = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_3422_323)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.3155 -0.000488281C1.93211 -0.000488281 0 1.93163 0 4.31501V11.684C0 14.0674 1.93211 15.9995 4.3155 15.9995H11.6845C14.0679 15.9995 16 14.0674 16 11.684V4.31501C16 1.93163 14.0679 -0.000488281 11.6845 -0.000488281H4.3155ZM10.3621 1.99951C10.3619 2.69113 10.613 3.35926 11.0687 3.87951C11.9754 4.92618 13.2287 4.86618 13.2287 4.86618V6.92618C12.2003 6.92794 11.1974 6.60608 10.3621 6.00618V10.1995C10.3621 12.2995 8.66206 13.9995 6.56872 13.9995C4.61539 13.9995 2.77539 12.4195 2.77539 10.1995C2.77539 7.91951 4.78872 6.13284 7.08872 6.43951V8.54618C5.94872 8.19284 4.84206 9.05284 4.84206 10.1995C4.84206 11.1595 5.62872 11.9328 6.57539 11.9328C7.02302 11.9328 7.45316 11.759 7.77523 11.4481C8.0973 11.1373 8.28617 10.7135 8.30206 10.2662V1.99951H10.3621Z"
          fill="#434343"
        />
      </g>
      <defs>
        <clipPath id="clip0_3422_323">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
